export default __webpack_public_path__ + "static/media/media-residential-3.aa85976e.jpg";